import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import createStore from '@/store'
import accessControl from '../middleware/accessControl';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/LoginView.vue')
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: () => import('../views/AboutView.vue')
  // },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/app/DashboardApp.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/kardex',
    name: 'kardex',
    component: () => import('@/views/app/kardex/ItemKardexView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/ingresos-egresos',
    name: 'ingresos-egresos',
    component: () => import('@/views/app/kardex/IngresosEgresosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/inventario',
    name: 'inventario',
    component: () => import('@/views/app/inventario/InventarioView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/item/:id',
    name: 'item',
    component: () => import('@/views/app/inventario/ItemInventarioView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/detailitem/:id',
    name: 'detailitem',
    component: () => import('@/views/app/inventario/ItemDetailView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/cambiarimpuestos',
    name: 'cambiarimpuestos',
    component: () => import('@/views/app/materiales/CambiarImpuestosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/barcodegenerator',
    name: 'barcodegenerator',
    component: () => import('@/views/app/materiales/BarCodeGeneratorView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/proveedores',
    name: 'proveedores',
    component: () => import('@/views/app/proveedores/ProveedoresView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/proveedor/:id',
    name: 'proveedor',
    component: () => import('@/views/app/proveedores/ItemProveedorView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/app/UserProfile.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/configuration',
    name: 'configuration',
    component: () => import('../views/app/config/GeneralConfigurationView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/rol',
    name: 'rol',
    component: () => import('../views/app/roles/GestionRol.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/rol/asignar-ruta',
    name: 'rolRuta',
    component: () => import('../views/app/roles/AsignarRutas.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/app/users/ManageUsers.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/users/form',
    name: 'usersForm',
    component: () => import('../views/app/users/FormView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/clientes',
    name: 'clientes',
    component: () => import('../views/app/clientes/ClientView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/clientes-stats/:id',
    name: 'clientes-stats',
    component: () => import('../views/app/clientes/StatsClientView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/cliente/:id',
    name: 'cliente',
    component: () => import('@/views/app/clientes/ItemClienteView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/prints',
    name: 'prints',
    component: () => import('../views/app/PrintsView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/stocks',
    name: 'stocks',
    component: () => import('../views/app/inventario/InventarioStockView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import('../views/app/CategoriesView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/comprobantes',
    name: 'comprobantes',
    component: () => import('../views/app/comprobantes/ComprobantesView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/admin-comprobantes',
    name: 'admin-comprobantes',
    component: () => import('../views/app/comprobantes/AdminComprobantesView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/comprobante',
    name: 'comprobante',
    component: () => import('../views/app/comprobantes/NewComprobanteView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/recibo',
    name: 'recibo',
    component: () => import('../views/app/comprobantes/NewReciboView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/comprobantexml',
    name: 'comprobantexml',
    component: () => import('../views/app/comprobantes/ComprobanteXmlView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/loadcomprobantexml',
    name: 'loadcomprobantexml',
    component: () => import('../views/app/comprobantesxml/LoadXmlComprobanteView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/processcomprobantexml',
    name: 'processcomprobantexml',
    component: () => import('../views/app/comprobantesxml/ProcessXmlComprobanteView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/viewcomprobantexml/:id',
    name: 'viewcomprobantexml',
    component: () => import('../views/app/comprobantesxml/ViewXmlComprobanteView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/caja/gestionar-caja',
    name: 'gestionar-caja',
    component: () => import('../views/app/cajas/GestionarCajaView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/caja/detalle/:id',
    name: 'detalleCaja',
    component: () => import('../views/app/cajas/DetalleCajasView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/caja/egresos-caja',
    name: 'egresos-caja',
    component: () => import('../views/app/cajas/EgresosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/caja/egreso-caja/:id',
    name: 'egreso-caja',
    component: () => import('../views/app/cajas/ItemEgresoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/caja/detalle/transacciones/:id',
    name: 'detalleTransacciones',
    component: () => import('../views/app/cajas/DetalleTransaccionesView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/reportes-generales',
    name: 'reportes-generales',
    component: () => import('../views/app/reportes/ReportesGeneralesView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/reportes-manifiestos',
    name: 'reportes-manifiestos',
    component: () => import('../views/app/reportes/ReportesManifiestosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/excelmanifiestos-reporte1',
    name: 'excelmanifiestos-reporte1',
    component: () => import('../views/app/reportes/ManifiestosExel3View.vue'),
    // component: () => import('../views/app/reportes/ManifiestosExel2View.vue'),
    // component: () => import('../views/app/reportes/ManifiestosExel1View.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/excellogistica-reporte1',
    name: 'excellogistica-reporte1',
    component: () => import('../views/app/reportes/LogisticaExel1View.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/publicaciones',
    name: 'publicaciones',
    component: () => import('../views/app/catalogo/PublicacionesView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/publicacion/:id',
    name: 'publicacion',
    component: () => import('../views/app/catalogo/PublicacionView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/publicacion-pictures/:id',
    name: 'publicacion-pictures',
    component: () => import('../views/app/catalogo/PicturesPublicacionView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/notificaciones',
    name: 'notificaciones',
    component: () => import('../views/app/notificaciones/NotificationsView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/contratos',
    name: 'contratos',
    component: () => import('@/views/app/contratos/ContratosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/contrato/:id',
    name: 'contrato',
    component: () => import('@/views/app/contratos/ItemContratoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/detailcontrato/:id',
    name: 'detailcontrato',
    component: () => import('@/views/app/contratos/ItemDetailContratoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/categories-contratos',
    name: 'categories-contratos',
    component: () => import('@/views/app/contratos/CategoriesContratosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/tipos-referencias',
    name: 'tipos-referencias',
    component: () => import('@/views/app/contratos/TiposReferenciasView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/entidades',
    name: 'entidades',
    component: () => import('@/views/app/entidades/EntidadesView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/entidad/:id',
    name: 'entidad',
    component: () => import('@/views/app/entidades/ItemEntidadView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/receptores',
    name: 'receptores',
    component: () => import('@/views/app/receptores/ReceptoresView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/receptor/:id',
    name: 'receptor',
    component: () => import('@/views/app/receptores/ItemReceptorView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/operarios',
    name: 'operarios',
    component: () => import('@/views/app/receptores/OperariosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/operario/:id',
    name: 'operario',
    component: () => import('@/views/app/receptores/FormOperarioView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/manifiestos',
    name: 'manifiestos',
    component: () => import('@/views/app/manifiestos/ManifiestosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/manifiesto/:id',
    name: 'manifiesto',
    component: () => import('@/views/app/manifiestos/ItemManifiestoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/manifiestorecords/:id',
    name: 'manifiestorecords',
    component: () => import('@/views/app/manifiestos/ItemManifiestoRecordsView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/manifiestoedit/:id',
    name: 'manifiestoedit',
    component: () => import('@/views/app/manifiestos/ItemManifiestoEditView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/componentes',
    name: 'componentes',
    component: () => import('@/views/app/manifiestos/ComponentesView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/vehiculos',
    name: 'vehiculos',
    component: () => import('@/views/app/vehiculos/VehiculosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/vehiculo/:id',
    name: 'vehiculo',
    component: () => import('@/views/app/vehiculos/ItemVehiculoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/conductores',
    name: 'conductores',
    component: () => import('@/views/app/choferes/ChoferesView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/conductor/:id',
    name: 'conductor',
    component: () => import('@/views/app/choferes/ItemChoferView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/rutas-recorrido',
    name: 'rutas-recorrido',
    component: () => import('@/views/app/rutasrecorrido/RutasRecorridoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/ruta-recorrido/:id',
    name: 'ruta-recorrido',
    component: () => import('@/views/app/rutasrecorrido/ItemRutaRecorridoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  // {
  //   path: '/empleados',
  //   name: 'empleados',
  //   component: () => import('@/views/app/rrhh/EmpleadosView.vue'),
  //   meta: {
  //     autenticado: true,
  //     middleware: accessControl
  //   }
  // },
  // {
  //   path: '/empleado/:id',
  //   name: 'empleado',
  //   component: () => import('@/views/app/rrhh/FormEmpleadoView.vue'),
  //   meta: {
  //     autenticado: true,
  //     middleware: accessControl
  //   }
  // },
  // {
  //   path: '/personas',
  //   name: 'personas',
  //   component: () => import('@/views/app/personas/PersonasView.vue'),
  //   meta: {
  //     autenticado: true,
  //     middleware: accessControl
  //   }
  // },
  // {
  //   path: '/persona/:id',
  //   name: 'persona',
  //   component: () => import('@/views/app/personas/FormPersonaView.vue'),
  //   meta: {
  //     autenticado: true,
  //     middleware: accessControl
  //   }
  // },
  // {
  //   path: '/cargos',
  //   name: 'cargos',
  //   component: () => import('@/views/app/rrhh/CargosView.vue'),
  //   meta: {
  //     autenticado: true,
  //     middleware: accessControl
  //   },
  // },
  {
    path: '/registradores',
    name: 'registradores',
    component: () => import('@/views/app/entidades/RegistradoresView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/registrador/:id',
    name: 'registrador',
    component: () => import('@/views/app/entidades/FormRegistradorView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/motivos-anulacion',
    name: 'motivos-anulacion',
    component: () => import('@/views/app/manifiestos/MotivosAnulacionView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/motivos-inactividad',
    name: 'motivos-inactividad',
    component: () => import('@/views/app/contratos/MotivosInactividadView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  //REPORTES
  {
    path: '/excel-comprobantes',
    name: 'excel-comprobantes',
    component: () => import('../views/app/reports/ComprobantesExelView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  // MATERIALES
  {
    path: '/bodegas',
    name: 'bodegas',
    component: () => import('../views/app/materiales/BodegasView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/bodega/:id',
    name: 'bodega',
    component: () => import('../views/app/materiales/FormBodegaView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/bodega-encargado/:id',
    name: 'bodega-encargado',
    component: () => import('../views/app/materiales/FormEncargadosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/bodega-layout/:id',
    name: 'bodega-layout',
    component: () => import('../views/app/bodegas/FormLayoutView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/categorias-item',
    name: 'categorias-item',
    component: () => import('../views/app/materiales/CategoriasItemView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/materiales',
    name: 'materiales',
    component: () => import('../views/app/materiales/ListarItemsView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/material/:id',
    name: 'material',
    component: () => import('../views/app/materiales/FormItemView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/kardex-material/:id',
    name: 'kardex-material',
    component: () => import('../views/app/materiales/KardexItemView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/kardexes',
    name: 'kardexes',
    component: () => import('../views/app/bodegas/KardexesView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/ordenes-compra',
    name: 'ordenes-compra',
    component: () => import('../views/app/materiales/OrdenesCompraView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/orden-compra',
    name: 'orden-compra',
    component: () => import('../views/app/materiales/OrdenCompraView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/kardex-ingreso/:id',
    name: 'kardex-ingreso',
    component: () => import('../views/app/bodegas/KardexIngresoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/kardex-egreso',
    name: 'kardex-egreso',
    component: () => import('../views/app/bodegas/KardexEgresoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/barcode',
    name: 'barcode',
    component: () => import('../views/app/materiales/BarCodeView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/materialesenbodegas',
    name: 'materialesenbodegas',
    component: () => import('../views/app/materiales/MaterialesBodegaView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/unidad-negocio/:id',
    name: 'unidad-negocio',
    component: () => import('../views/app/costeo/UnidadNegocioView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/unidades-negocio',
    name: 'unidades-negocio',
    component: () => import('../views/app/costeo/UnidadesNegocioView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/tipos-unidad-negocio',
    name: 'tipos-unidad-negocio',
    component: () => import('../views/app/costeo/TiposUnidadesNegocios.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/administrar-bodegas',
    name: 'administrar-bodegas',
    component: () => import('../views/app/bodegas/AdministrarBodegasView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/materiales-bodega/:id',
    name: 'materiales-bodega',
    component: () => import('../views/app/bodegas/MaterialesBodegaView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/kardex-item-bodega/:bodegaId/:id/',
    name: 'kardex-item-bodega',
    component: () => import('../views/app/bodegas/KardexItemBodega.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/bodega-auxiliares/:id',
    name: 'bodega-auxiliares',
    component: () => import('../views/app/bodegas/FormAuxiliaresView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/pickers',
    name: 'pickers',
    component: () => import('../views/app/egresos/FormPickersView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/egresos-cum',
    name: 'egresos-cum',
    component: () => import('../views/app/egresos/ListarEgresosConsumo.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/egreso-cum/:id',
    name: 'egreso.cum',
    component: () => import('../views/app/egresos/EgresoConsumoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/egreso-transito/:id/:userId',
    name: 'egreso-transito',
    component: () => import('../views/app/egresos/EgresoTransitoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/egresos-transito',
    name: 'egresos-transito',
    component: () => import('../views/app/egresos/ListarEgresosTransito.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/efectivizar-transito/:id',
    name: 'efectivizar-transito',
    component: () => import('../views/app/egresos/EfectivizarTransitoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/efectivizar-usomateriales/:id',
    name: 'efectivizar-usomateriales',
    component: () => import('../views/app/egresos/UsoMaterialesView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/personas',
    name: 'personas',
    component: () => import('../views/app/person/PersonsView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/persona/:id',
    name: 'persona',
    component: () => import('../views/app/person/FormPersonView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  // PERSONAS Y EMPLEADOS
  {
    path: '/empleados',
    name: 'empleados',
    component: () => import('../views/app/person/EmpleadosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/empleado/:id',
    name: 'empleado',
    component: () => import('../views/app/person/FormEmpleadoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/documentacion-empleado/:id',
    name: 'documentacion-empleado',
    component: () => import('../views/app/person/DocumentosEmpleadoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/zonas',
    name: 'zonas',
    component: () => import('../views/app/zonas/ZonasView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/zona/:id',
    name: 'zona',
    component: () => import('../views/app/zonas/FormZonaView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/cargos',
    name: 'cargos',
    component: () => import('../views/app/person/CargosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    
    }
  },
  // CAJA DE PAGOS
  {
    path: '/cajas-pagos',
    name: 'cajas-pagos',
    component: () => import('../views/app/cajapagos/ListarCajasPagos.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/caja-pagos/:id',
    name: 'caja-pagos',
    component: () => import('../views/app/cajapagos/CajaPagosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/movimientos-cajapagos/:id',
    name: 'movimientos-cajapagos',
    component: () => import('../views/app/cajapagos/MovimientosCajaPagos.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/mis-cajaspagos',
    name: 'mis-cajaspagos',
    component: () => import('../views/app/cajapagos/MisCajasPagos.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/ingreso-cajapagos/:id',
    name: 'ingreso-cajapagos',
    component: () => import('../views/app/cajapagos/IngresoCajaPagos.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/egreso-cajapagos/:id',
    name: 'egreso-cajapagos',
    component: () => import('../views/app/cajapagos/EgresoCajaPagos.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/detalle-movimiento-cajapagos/:id/:cajaId',
    name: 'detalle-movimiento-cajapagos',
    component: () => import('../views/app/cajapagos/DetalleMovimientoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/tipos-cajaspagos',
    name: 'tipos-cajaspagos',
    component: () => import('../views/app/cajapagos/TiposCajasPagos.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/tipos-pagoscajas',
    name: 'tipos-pagoscajas',
    component: () => import('../views/app/cajapagos/TiposPagosCajas.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  // ANALITICA
  // {
  //   path: '/analitica-maquinaria-tracking/:id',
  //   name: 'analitica-maquinaria-tracking',
  //   component: () => import('../views/app/analitica/AnaliticaTrackingView.vue'),
  //   meta: {
  //     autenticado: true,
  //     middleware: accessControl
  //   }
  // },
  // {
  //   path: '/analitica-maquinaria-mantenimientos/:id',
  //   name: 'analitica-maquinaria-mantenimientos',
  //   component: () => import('../views/app/analitica/AnaliticaMantenimientosView.vue'),
  //   meta: {
  //     autenticado: true,
  //     middleware: accessControl
  //   }
  // },
  {
    path: '/analitica-materiales',
    name: 'analitica-materiales',
    component: () => import('../views/app/analitica/AnaliticaMaterialesView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/analitica-estados-financieros',
    name: 'analitica-estados-financieros',
    component: () => import('../views/app/analitica/AnaliticaFinancierosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  // EXTRAS
  {
    path: '/tipos-descuentos',
    name: 'tipos-descuentos',
    component: () => import('../views/app/config/DescuentosView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/formaspago',
    name: 'formaspago',
    component: () => import('@/views/app/config/FormasPagoView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
  {
    path: '/firebase-utils',
    name: 'firebase-utils',
    component: () => import('@/views/app/config/FirebaseUtilsView.vue'),
    meta: {
      autenticado: true,
      middleware: accessControl
    }
  },
]

Vue.use(VueRouter)

const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // the relevant part
}

// router.beforeEach(async (to, from) => {
//   console.log('direcciones to, from', to, from)
// })

router.beforeEach(async (to, from, next) => {
  let usuario = null;
  await createStore().then((store) => {
    usuario = store.getters.logeado;
  });
  let autorizacion = to.matched.some((record) => record.meta.autenticado);
  if (autorizacion && !usuario) {
    next("/");
  } else if (!autorizacion && usuario) {
    next("/dashboard");
  } else if (autorizacion && usuario) {
    if (to.meta.middleware) {
      const middleware = to.meta.middleware;
      middleware({ next, to });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router
